:host {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center
}

::slotted(afs-image),
::slotted(div) {
  height: var(--slot-height);
  margin: var(--slot-margin);
}